import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Tooltip } from '@mm/components';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import classnames from 'classnames';
import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';

type Props = {
  css?: {
    container?: string;
    icon: string;
  };
  icon?: ReactNode;
  title: ReactNode;
  subtitle?: string;
  featureFlag?: string;
  landmineName: string;
  headerRightComponent?: ReactNode;
  upgradeButtonName?: string;
  haveErrors?: boolean;
};

export const BaseIntegrationHeader = (props: Props) => {
  const {
    css,
    icon,
    title,
    subtitle,
    featureFlag,
    landmineName,
    headerRightComponent,
    upgradeButtonName = 'Add an Account',
    haveErrors,
  } = props;

  const headerClassname = classnames(
    'integrations__header',
    'integrations__header--account-connected',
    css?.container,
  );
  const featureFlags = useSelector(combinedFeatureFlagsSelector);
  const hasFeatureFlag = featureFlag ? !!featureFlags[featureFlag] : true;
  const { openNewBillingModal2023 } = useModalActions();

  const showUpgradeModal = e => {
    e.stopPropagation();
    openNewBillingModal2023({
      landmineName,
    });
  };

  const renderErrorIcon = () => {
    if (haveErrors) {
      return (
        <Tooltip
          withoutLine
          useHover={true}
          anchorElement={
            <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />
          }
        >
          One or more entities have errors. Please check your accounts
          configurations and permissions or reconnect
        </Tooltip>
      );
    }
  };

  return (
    <div className={headerClassname}>
      <div className="integrations__header-main">
        {icon && (
          <div className={classnames('integrations__header-icon', css?.icon)}>
            {icon}
          </div>
        )}
        <div className="integrations__header-text">
          <div className="integrations__header-title">
            {title} {renderErrorIcon()}
          </div>
          {subtitle && (
            <div className="integrations__header-info">
              <div className="integrations__header-learn-more">{subtitle}</div>
            </div>
          )}
        </div>
      </div>

      {!hasFeatureFlag ? (
        <Button
          onClick={showUpgradeModal}
          color="secondary-blue"
          css={{ container: 'integrations__header-add-button-secondary' }}
        >
          {upgradeButtonName}
        </Button>
      ) : (
        headerRightComponent
      )}
    </div>
  );
};
